import { Button, Modal, Form, Input, message, DatePicker } from "antd";
import API from "../../../../services/api-request";
import TextArea from "antd/es/input/TextArea";
import SelectCompany from "../../../../components/SelectCompany";

const AddSubscription = (props) => {
  const [addForm] = Form.useForm();

  const onFinish = async (values) => {
    const { company_id, paket, start_date, end_date } = values;

    const dataForm = {
      company_id,
      package: paket,
      start_date,
      end_date,
    };

    await API.Post("subscription", dataForm)
      .then(() => {
        message.success("Subscription has been added");
        props.onGetSubscription();
        addForm.resetFields();
        props.onShowAdd(false);
      })
      .catch((err) => {
        console.log(err);
        message.info(`${err?.response?.data?.error}`);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleCancel = () => {
    props.onShowAdd(false);
    addForm.resetFields();
  };

  return (
    <>
      <Modal
        title="Add Subscription"
        open={props.showAdd}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="default" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={() => addForm.submit()}>
            Submit
          </Button>,
        ]}
      >
        <Form
          form={addForm}
          name="Add Form"
          style={{
            margin: "0 auto",
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Select Company"
            name="company_id"
            rules={[{ required: true, message: "Please input name!" }]}
          >
            <SelectCompany />
          </Form.Item>
          <Form.Item
            label="Package"
            name="paket"
            rules={[{ required: true, message: "Please input package!" }]}
          >
            <Input placeholder="Input package" />
          </Form.Item>
          <Form.Item
            label="Start Date"
            name="start_date"
            rules={[{ required: true, message: "Please input Start Date!" }]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
          <Form.Item
            label="End Date"
            name="end_date"
            rules={[{ required: true, message: "Please input End Date!" }]}
          >
            <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddSubscription;
